var _path, _path2, _path3, _path4, _g, _path5, _g2, _path6, _path7, _path8, _path9, _g3, _g4, _path10, _g5, _path11, _g6, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g7, _path19, _path20, _path21, _path22, _g8, _g9, _path23, _path24, _path25, _polygon, _circle, _path26, _g10, _path27, _path28, _path29, _g11, _path30, _g12, _path31, _ellipse, _ellipse2, _path32, _path33;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 850.54,
    height: 740.83,
    "data-name": "Layer 1",
    viewBox: "0 0 850.54 740.83",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m941.61 465.12a354.21 354.21 0 0 1-98.85 245.9q-5.7449 6.015-11.8 11.74-9.225 8.775-19.07 16.87a353.93 353.93 0 0 1-217.58 80.69q-3.9749 0.09-7.98 0.09c-63.43 0-143.21-33.88-215.61-80.78q-8.985-5.82-17.81-11.91-4.125-2.82-8.21-5.72a730.43 730.43 0 0 1-79.32-64.8 514.12 514.12 0 0 1-45.75-48.92c-55.63-68.62-67.9-130.45 11.41-143.16q14.085-2.25 27.34-4.81 19.2-3.69 36.75-7.97 23.64-5.745 44.42-12.46 6.99-2.25 13.66-4.59c65.74-23.09 109.74-53.2 139.69-85.87q7.62-8.295 14.05-16.79a236.06 236.06 0 0 0 17.83-27.12 254.9 254.9 0 0 0 18.41-41.05l0.27-0.78c23.83-68.74 16.58-132.5 42.87-153.84 112.38-91.23 252.29 38.69 317.96 191.9q4.965 11.58 9.34 23.3 1.965 5.2351 3.79 10.49 4.7999 13.695 8.71 27.46 1.5 5.25 2.86 10.49c0.97 3.77 1.9 7.53 2.76 11.29 6.3899 27.53 9.8599 54.68 9.8599 80.35z",
    fill: "#5c8092",
    fillOpacity: 0.096774
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m594.31 820.32q-3.9749 0.09-7.98 0.09c-63.43 0-143.21-33.88-215.61-80.78q-8.985-5.82-17.81-11.91l5.16-31.4 156.21-20.74 78.4 59.95z",
    fill: "#161e25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m601.83 259.63h-22.26a2.601 2.601 0 0 0-2.5998 2.5998v22.27a2.5926 2.5926 0 0 0 2.5998 2.5901h22.26a2.5992 2.5992 0 0 0 2.6001-2.5901v-22.27a2.6076 2.6076 0 0 0-2.6001-2.5998z",
    fill: "#f0f0f0",
    fillOpacity: 0.24194
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m601.83 297.58h-22.26a2.601 2.601 0 0 0-2.5998 2.6v22.27a2.5925 2.5925 0 0 0 2.5998 2.59h22.26a2.5991 2.5991 0 0 0 2.6001-2.59v-22.27a2.6076 2.6076 0 0 0-2.6001-2.6z",
    fill: "#f0f0f0",
    fillOpacity: 0.24194
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e6e6e6"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m601.83 335.53h-22.26a2.6012 2.6012 0 0 0-2.5998 2.6001v22.26a2.5946 2.5946 0 0 0 2.5998 2.5998h22.26a2.6012 2.6012 0 0 0 2.6001-2.5998v-22.26a2.6077 2.6077 0 0 0-2.6001-2.6001z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m604.39 375.62a2.6171 2.6171 0 0 0-2.5601-2.1401h-22.26a2.6012 2.6012 0 0 0-2.5998 2.6001v22.26a2.5947 2.5947 0 0 0 2.5998 2.6h22.26a2.6013 2.6013 0 0 0 2.6001-2.6v-22.26a2.3127 2.3127 0 0 0-0.04004-0.45996z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m602.84 411.63a2.634 2.634 0 0 0-1.01-0.20008h-22.26a2.5948 2.5948 0 0 0-2.5998 2.6v22.26a2.5884 2.5884 0 0 0 2.5998 2.6001h22.26a2.6014 2.6014 0 0 0 2.6001-2.6001v-22.26a2.6158 2.6158 0 0 0-1.5901-2.3999z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m648.59 259.63h-22.26a2.601 2.601 0 0 0-2.5998 2.5998v22.27a2.5926 2.5926 0 0 0 2.5998 2.5901h22.26a2.5992 2.5992 0 0 0 2.6001-2.5901v-22.27a2.6076 2.6076 0 0 0-2.6001-2.5998z",
    fill: "#f0f0f0",
    fillOpacity: 0.24194
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.70161
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m648.59 297.58h-22.26a2.601 2.601 0 0 0-2.5998 2.6v22.27a2.5925 2.5925 0 0 0 2.5998 2.59h22.26a2.5991 2.5991 0 0 0 2.6001-2.59v-22.27a2.6076 2.6076 0 0 0-2.6001-2.6z",
    fill: "#1bb5b9"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m648.59 335.53h-22.26a2.6012 2.6012 0 0 0-2.5998 2.6001v22.26a2.5946 2.5946 0 0 0 2.5998 2.5998h22.26a2.6012 2.6012 0 0 0 2.6001-2.5998v-22.26a2.6077 2.6077 0 0 0-2.6001-2.6001z",
    fill: "#1bba96"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m648.59 373.48h-22.26a2.5926 2.5926 0 0 0-2.46 1.78 2.4785 2.4785 0 0 0-0.13989 0.82007v22.26a2.5947 2.5947 0 0 0 2.5998 2.6h22.26a2.6013 2.6013 0 0 0 2.6001-2.6v-22.26a2.6078 2.6078 0 0 0-2.6001-2.6001z",
    fill: "#1bba96"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m648.59 411.43h-22.26a2.5948 2.5948 0 0 0-2.5998 2.6v22.26a2.5948 2.5948 0 0 0 2.5998 2.6001h22.26a2.6014 2.6014 0 0 0 2.6001-2.6001v-22.26a2.6013 2.6013 0 0 0-2.6001-2.6z",
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m695.35 259.63h-22.26a2.601 2.601 0 0 0-2.5998 2.5998v22.27a2.5926 2.5926 0 0 0 2.5998 2.5901h22.26a2.5992 2.5992 0 0 0 2.6001-2.5901v-22.27a2.6076 2.6076 0 0 0-2.6001-2.5998z",
    fill: "#1bb5b9",
    fillOpacity: 0.70161
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m695.35 297.58h-22.26a2.601 2.601 0 0 0-2.5998 2.6v22.27a2.5925 2.5925 0 0 0 2.5998 2.59h22.26a2.5991 2.5991 0 0 0 2.6001-2.59v-22.27a2.6076 2.6076 0 0 0-2.6001-2.6z",
    fill: "#1bba96",
    fillOpacity: 0.70161
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m695.35 335.53h-22.26a2.6012 2.6012 0 0 0-2.5998 2.6001v22.26a2.5946 2.5946 0 0 0 2.5998 2.5998h22.26a2.6012 2.6012 0 0 0 2.6001-2.5998v-22.26a2.6077 2.6077 0 0 0-2.6001-2.6001z",
    fill: "#f0f0f0",
    fillOpacity: 0.24194
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.70161
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m695.35 373.48h-22.26a2.6012 2.6012 0 0 0-2.5998 2.6001v22.26a2.5947 2.5947 0 0 0 2.5998 2.6h22.26a2.6013 2.6013 0 0 0 2.6001-2.6v-22.26a2.6078 2.6078 0 0 0-2.6001-2.6001z",
    fill: "#1bb5b9"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m695.35 411.43h-22.26a2.5948 2.5948 0 0 0-2.5998 2.6v22.26a2.5948 2.5948 0 0 0 2.5998 2.6001h22.26a2.6014 2.6014 0 0 0 2.6001-2.6001v-22.26a2.6013 2.6013 0 0 0-2.6001-2.6z",
    fill: "#1bba96"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m742.11 259.63h-22.26a2.6011 2.6011 0 0 0-2.6 2.5998v22.27a2.5928 2.5928 0 0 0 2.6 2.5901h22.26a2.5992 2.5992 0 0 0 2.6001-2.5901v-22.27a2.6076 2.6076 0 0 0-2.6001-2.5998z",
    fill: "#1bb5b9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#f0f0f0",
    fillOpacity: 0.24194
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m742.11 297.58h-22.26a2.6012 2.6012 0 0 0-2.6 2.6v22.27a2.5926 2.5926 0 0 0 2.6 2.59h22.26a2.5991 2.5991 0 0 0 2.6001-2.59v-22.27a2.6076 2.6076 0 0 0-2.6001-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m742.11 335.53h-22.26a2.6013 2.6013 0 0 0-2.6 2.6001v22.26a2.5947 2.5947 0 0 0 2.6 2.5998h22.26a2.6012 2.6012 0 0 0 2.6001-2.5998v-22.26a2.6077 2.6077 0 0 0-2.6001-2.6001z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m742.11 373.48h-22.26a2.6013 2.6013 0 0 0-2.6 2.6001v22.26a2.5948 2.5948 0 0 0 2.6 2.6h22.26a2.6013 2.6013 0 0 0 2.6001-2.6v-22.26a2.6078 2.6078 0 0 0-2.6001-2.6001z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m742.11 411.43h-22.26a2.5948 2.5948 0 0 0-2.6 2.6v22.26a2.595 2.595 0 0 0 2.6 2.6001h22.26a2.6014 2.6014 0 0 0 2.6001-2.6001v-22.26a2.6013 2.6013 0 0 0-2.6001-2.6z",
    fill: "#1bba96",
    fillOpacity: 0.70161
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#f0f0f0",
    fillOpacity: 0.24194
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m788.87 259.63h-22.27a2.599 2.599 0 0 0-2.59 2.5998v22.27a2.5906 2.5906 0 0 0 2.59 2.5901h22.27a2.5992 2.5992 0 0 0 2.6001-2.5901v-22.27a2.6076 2.6076 0 0 0-2.6001-2.5998z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m788.87 297.58h-22.27a2.599 2.599 0 0 0-2.59 2.6v22.27a2.5905 2.5905 0 0 0 2.59 2.59h22.27a2.5991 2.5991 0 0 0 2.6001-2.59v-22.27a2.6076 2.6076 0 0 0-2.6001-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m788.87 335.53h-22.27a2.5992 2.5992 0 0 0-2.59 2.6001v22.26a2.5926 2.5926 0 0 0 2.59 2.5998h22.27a2.6012 2.6012 0 0 0 2.6001-2.5998v-22.26a2.6077 2.6077 0 0 0-2.6001-2.6001z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m788.87 373.48h-22.27a2.5992 2.5992 0 0 0-2.59 2.6001v22.26a2.5927 2.5927 0 0 0 2.59 2.6h22.27a2.6013 2.6013 0 0 0 2.6001-2.6v-22.26a2.6078 2.6078 0 0 0-2.6001-2.6001z",
    fill: "#1bb5b9",
    fillOpacity: 0.70161
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#f0f0f0",
    fillOpacity: 0.24194
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m788.87 411.43h-22.27a2.5927 2.5927 0 0 0-2.59 2.6v22.26a2.5928 2.5928 0 0 0 2.59 2.6001h22.27a2.6014 2.6014 0 0 0 2.6001-2.6001v-22.26a2.6013 2.6013 0 0 0-2.6001-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m835.63 259.63h-22.27a2.599 2.599 0 0 0-2.59 2.5998v22.27a2.5906 2.5906 0 0 0 2.59 2.5901h22.27a2.5993 2.5993 0 0 0 2.6001-2.5901v-22.27a2.6077 2.6077 0 0 0-2.6001-2.5998z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m835.63 297.58h-22.27a2.599 2.599 0 0 0-2.59 2.6v22.27a2.5905 2.5905 0 0 0 2.59 2.59h22.27a2.5992 2.5992 0 0 0 2.6001-2.59v-22.27a2.6077 2.6077 0 0 0-2.6001-2.6z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m835.63 335.53h-22.27a2.5992 2.5992 0 0 0-2.59 2.6001v22.26a2.5926 2.5926 0 0 0 2.59 2.5998h22.27a2.6012 2.6012 0 0 0 2.6001-2.5998v-22.26a2.6078 2.6078 0 0 0-2.6001-2.6001z",
    fill: "#1bba96",
    fillOpacity: 0.70161
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m835.63 373.48h-22.27a2.5992 2.5992 0 0 0-2.59 2.6001v22.26a2.5927 2.5927 0 0 0 2.59 2.6h22.27a2.6013 2.6013 0 0 0 2.6001-2.6v-22.26a2.6079 2.6079 0 0 0-2.6001-2.6001z",
    fill: "#f0f0f0",
    fillOpacity: 0.24194
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m835.63 411.43h-22.27a2.5927 2.5927 0 0 0-2.59 2.6v22.26a2.5928 2.5928 0 0 0 2.59 2.6001h22.27a2.6015 2.6015 0 0 0 2.6001-2.6001v-22.26a2.6014 2.6014 0 0 0-2.6001-2.6z",
    fill: "#f0f0f0",
    fillOpacity: 0.24194
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m882.39 259.63h-22.27a2.599 2.599 0 0 0-2.59 2.5998v22.27a2.5906 2.5906 0 0 0 2.59 2.5901h22.27a2.5993 2.5993 0 0 0 2.6001-2.5901v-22.27a2.6077 2.6077 0 0 0-2.6001-2.5998z",
    fill: "#1bb5b9",
    fillOpacity: 0.70161
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m882.39 297.58h-22.27a2.599 2.599 0 0 0-2.59 2.6v22.27a2.5905 2.5905 0 0 0 2.59 2.59h22.27a2.5992 2.5992 0 0 0 2.6001-2.59v-22.27a2.6077 2.6077 0 0 0-2.6001-2.6z",
    fill: "#1bba96",
    fillOpacity: 0.70161
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m882.39 335.53h-22.27a2.5992 2.5992 0 0 0-2.59 2.6001v22.26a2.5926 2.5926 0 0 0 2.59 2.5998h22.27a2.6012 2.6012 0 0 0 2.6001-2.5998v-22.26a2.6078 2.6078 0 0 0-2.6001-2.6001z",
    fill: "#f0f0f0",
    fillOpacity: 0.24194
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m882.39 373.48h-22.27a2.5992 2.5992 0 0 0-2.59 2.6001v22.26a2.5927 2.5927 0 0 0 2.59 2.6h22.27a2.6013 2.6013 0 0 0 2.6001-2.6v-22.26a2.6079 2.6079 0 0 0-2.6001-2.6001z",
    fill: "#f0f0f0",
    fillOpacity: 0.24194
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.70161
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m882.39 411.43h-22.27a2.5927 2.5927 0 0 0-2.59 2.6v22.26a2.5928 2.5928 0 0 0 2.59 2.6001h22.27a2.6015 2.6015 0 0 0 2.6001-2.6001v-22.26a2.6014 2.6014 0 0 0-2.6001-2.6z",
    fill: "#1bba96"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m929.15 259.63h-22.27a2.599 2.599 0 0 0-2.59 2.5998v22.27a2.5906 2.5906 0 0 0 2.59 2.5901h22.27a2.5992 2.5992 0 0 0 2.6-2.5901v-22.27a2.6076 2.6076 0 0 0-2.6-2.5998z",
    fill: "#1bba96"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m929.15 297.58h-22.27a2.599 2.599 0 0 0-2.59 2.6v22.27a2.5905 2.5905 0 0 0 2.59 2.59h22.27a2.5991 2.5991 0 0 0 2.6-2.59v-22.27a2.6076 2.6076 0 0 0-2.6-2.6z",
    fill: "#1bb5b9"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m929.15 335.53h-22.27a2.5992 2.5992 0 0 0-2.59 2.6001v22.26a2.5926 2.5926 0 0 0 2.59 2.5998h22.27a2.6011 2.6011 0 0 0 2.6-2.5998v-22.26a2.6077 2.6077 0 0 0-2.6-2.6001z",
    fill: "#f0f0f0",
    fillOpacity: 0.24194
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m929.15 373.48h-22.27a2.5992 2.5992 0 0 0-2.59 2.6001v22.26a2.5927 2.5927 0 0 0 2.59 2.6h22.27a2.6012 2.6012 0 0 0 2.6-2.6v-22.26a2.6078 2.6078 0 0 0-2.6-2.6001z",
    fill: "#1bba96",
    fillOpacity: 0.70161
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m929.15 411.43h-22.27a2.5927 2.5927 0 0 0-2.59 2.6v22.26a2.5928 2.5928 0 0 0 2.59 2.6001h22.27a2.6014 2.6014 0 0 0 2.6-2.6001v-22.26a2.6012 2.6012 0 0 0-2.6-2.6z",
    fill: "#1bb5b9",
    fillOpacity: 0.70161
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m975.91 259.63h-22.27a2.599 2.599 0 0 0-2.59 2.5998v22.27a2.5906 2.5906 0 0 0 2.59 2.5901h22.27a2.5992 2.5992 0 0 0 2.6-2.5901v-22.27a2.6076 2.6076 0 0 0-2.6-2.5998z",
    fill: "#f0f0f0",
    fillOpacity: 0.24194
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.70161
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m975.91 297.58h-22.27a2.599 2.599 0 0 0-2.59 2.6v22.27a2.5905 2.5905 0 0 0 2.59 2.59h22.27a2.5991 2.5991 0 0 0 2.6-2.59v-22.27a2.6076 2.6076 0 0 0-2.6-2.6z",
    fill: "#1bb5b9"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m975.91 335.53h-22.27a2.5992 2.5992 0 0 0-2.59 2.6001v22.26a2.5926 2.5926 0 0 0 2.59 2.5998h22.27a2.6011 2.6011 0 0 0 2.6-2.5998v-22.26a2.6077 2.6077 0 0 0-2.6-2.6001z",
    fill: "#1bba96"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m975.91 373.48h-22.27a2.5992 2.5992 0 0 0-2.59 2.6001v22.26a2.5927 2.5927 0 0 0 2.59 2.6h22.27a2.6012 2.6012 0 0 0 2.6-2.6v-22.26a2.6078 2.6078 0 0 0-2.6-2.6001z",
    fill: "#1bba96"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#f0f0f0",
    fillOpacity: 0.24194
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m975.91 411.43h-22.27a2.5927 2.5927 0 0 0-2.59 2.6v22.26a2.5928 2.5928 0 0 0 2.59 2.6001h22.27a2.6014 2.6014 0 0 0 2.6-2.6001v-22.26a2.6012 2.6012 0 0 0-2.6-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m1022.7 259.63h-22.27a2.5991 2.5991 0 0 0-2.5901 2.5998v22.27a2.5907 2.5907 0 0 0 2.5901 2.5901h22.27a2.5992 2.5992 0 0 0 2.6-2.5901v-22.27a2.6076 2.6076 0 0 0-2.6-2.5998z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m1022.7 297.58h-22.27a2.5992 2.5992 0 0 0-2.5901 2.6v22.27a2.5906 2.5906 0 0 0 2.5901 2.59h22.27a2.5991 2.5991 0 0 0 2.6-2.59v-22.27a2.6076 2.6076 0 0 0-2.6-2.6z"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m1022.7 335.53h-22.27a2.5993 2.5993 0 0 0-2.5901 2.6001v22.26a2.5927 2.5927 0 0 0 2.5901 2.5998h22.27a2.6011 2.6011 0 0 0 2.6-2.5998v-22.26a2.6077 2.6077 0 0 0-2.6-2.6001z",
    fill: "#1bb5b9",
    fillOpacity: 0.70161
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m1022.7 373.48h-22.27a2.5993 2.5993 0 0 0-2.5901 2.6001v22.26a2.5928 2.5928 0 0 0 2.5901 2.6h22.27a2.6012 2.6012 0 0 0 2.6-2.6v-22.26a2.6078 2.6078 0 0 0-2.6-2.6001z",
    fill: "#f0f0f0",
    fillOpacity: 0.24194
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m1022.7 411.43h-22.27a2.5928 2.5928 0 0 0-2.5901 2.6v22.26a2.5929 2.5929 0 0 0 2.5901 2.6001h22.27a2.6014 2.6014 0 0 0 2.6-2.6001v-22.26a2.6012 2.6012 0 0 0-2.6-2.6z",
    fill: "#f0f0f0",
    fillOpacity: 0.24194
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "336.1 660.05 335.48 660.05 336 659.98",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "b6132315-04e2-4cdb-a713-107c9cd58b0b",
    cx: 282.81,
    cy: 176.73,
    r: 68.322,
    fill: "#a88e8e",
    "data-name": "ab6171fa-7d69-4734-b81c-8dff60f9761b"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m517.38 206.23s17.869-34.161-21.444-37.266c0 0-33.515-30.402-67.676-5.558 0 0-18.633 0-28.823 21.086 0 0-14.655-5.558-17.876 9.3166 0 0-10.723 31.055 0 59.005s14.285 31.055 14.285 31.055-17.621-58.598 25.27-61.704 90.887-29.909 94.461 4.2514 8.9533 42.578 8.9533 42.578 33.95-48.789-7.152-62.764z",
    fill: "#19191f",
    "data-name": "bf427902-b9bf-4946-b5d7-5c1c7e04535e"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m634.28 424.69-0.2201 1.16-2.47 13.04-17.07 90.2-1.01 5.3101-2.12 11.23-2.8999 15.32-6.4302 33.95-1.8398 9.73-0.69006 3.6499-0.24 1.28-1.91 10.07-0.58 3.0399-4.66 34.53-4.0701 30.09 13.62 13.62-8.1201 8.12-5.3298 30.53 0.00989 0.07007h-217.53q-13.2-8.5501-26.02-17.63l1.79-13.4s6.1599-23.93 3.5698-26.79c-2.5798-2.86-8.24-7.97-8.24-7.97l7.1301-16.64 0.99-2.3099-1.66-34.43-0.03992-0.83-0.55-11.35-0.07007-1.46-0.11-2.1899-2.11-43.68-0.04-0.72009-0.63989-13.24-0.6001-12.59-0.26-5.3101-2.5699-53.13-1.74-36.08-1.52-31.41 6.11-2.0699 65.35-22.21 27.07-35.19 56.34 0.42 27.58 0.21009 46.02 42.68 10.47 5 0.08 0.04 7.5099 3.59 19.04 9.09 20.13 9.6201 10.33 4.9299z",
    fill: "#394050"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m443.84 637.14a30.286 30.286 0 0 1-40.664-22.43l-106.56-15.118 37.043-41.902 95.511 20.78a30.45 30.45 0 0 1 14.669 58.67z",
    fill: "#a88e8e"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m396.33 560.95a13.522 13.522 0 0 0-7.8899-4.87l-43.72-9.0901-4.49-0.92993a18.933 18.933 0 0 1-12.53-9.0701 19.161 19.161 0 0 1-2.45-7.8999 18.895 18.895 0 0 1 0.89-7.48l24.98-75.27a41.792 41.792 0 0 0 2.0901-11.05 43.349 43.349 0 0 0-9.0701-28.89 42.693 42.693 0 0 0-49.01-13.64c-0.25 0.09009-0.51 0.19006-0.76 0.29a42.583 42.583 0 0 0-25.31 28.41l-10.68 38.85-22.03 80.09a57.766 57.766 0 0 0 48.96 72.68l62.97 7.38 29.14 3.42a13.497 13.497 0 0 0 14.84-10.73 4.8954 4.8954 0 0 0 0.11-0.55005l0.7-4.3201 5.9301-36.38 0.05993-0.37012a13.475 13.475 0 0 0-2.73-10.58z",
    fill: "#394050"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m511.71 638.3a30.286 30.286 0 0 0 37.094-27.94l103.36-29.994-42.582-36.26-91.626 34.041a30.45 30.45 0 0 0-6.2488 60.152z",
    fill: "#a88e8e"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m703.49 513.27-49.16-113.14a42.819 42.819 0 0 0-20.27-21.35 43.356 43.356 0 0 0-8.7799-3.2c-0.4701-0.12-0.94007-0.23-1.41-0.32007a42.132 42.132 0 0 0-19.48 0.36011 42.814 42.814 0 0 0-27.34 21.73 1.0038 1.0038 0 0 0-0.08 0.13989 43.1 43.1 0 0 0-0.37012 38.85l0.61011 1.22 34.74 69.77a18.9 18.9 0 0 1-10.5 26.19l-2.4401 0.88013-43.88 15.85a13.497 13.497 0 0 0-8.33 16.79l0.11 0.3501 12.3 39.36c0.05994 0.18005 0.11987 0.36011 0.18994 0.54a7.0543 7.0543 0 0 0 0.4 0.99 13.482 13.482 0 0 0 15.81 7.53l23.68-6.25 4.83-1.28 61.15-16.15a57.76 57.76 0 0 0 38.22-78.86z",
    fill: "#394050"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m219.63 608.28a514.12 514.12 0 0 0 45.75 48.92h451.97a16.446 16.446 0 0 1 16.42 16.43l0.65 114.53a355.43 355.43 0 0 0 77.47-48.53q9.84-8.085 19.07-16.87 6.045-5.73 11.8-11.74a355.63 355.63 0 0 0 68.82-102.74z",
    fill: "#161b21"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m842.76 711.02q-5.7449 6.015-11.8 11.74h-96.21v-11.74z",
    fill: "#fff",
    fillOpacity: 0
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m633.38 335.53a5.5377 5.5377 0 0 0-4.87-2.8999h-327.84a5.5545 5.5545 0 0 0-5.54 5.5499v196.22h338.93v-196.22a5.3855 5.3855 0 0 0-0.67992-2.65z",
    fill: "#161e24"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m294.83 529.09v24.214a7.6438 7.6438 0 0 0 7.6438 7.6439h125.1v47.787h-1.6618a0.9929 0.9929 0 0 0-0.993 0.99292v3.3237a0.9929 0.9929 0 0 0 0.993 0.993h77.658a0.99291 0.99291 0 0 0 0.993-0.993v-3.3237a0.9929 0.9929 0 0 0-0.993-0.99292h-1.6618v-47.787h125.1a7.6438 7.6438 0 0 0 7.6438-7.6439v-24.214z",
    fill: "#131b21"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#2f8bb7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 285.9,
    cy: 348.7,
    r: 31.306,
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m540.4 252.58h-5c0-37.8-37.41-62.57-75.15-62.59a82.382 82.382 0 0 0-16.35 1.59c-6.06 1.21-12.35 2.66-18.53 4.55-24.37 7.47-46.97 21.91-46.97 56.45a78.591 78.591 0 0 0 2.54 19.88l-4.84 1.26a83.876 83.876 0 0 1-2.7-21.14c0-30.18 12.39-50.91 33.79-63.27 11.25-6.5 24.98-10.69 40.71-12.73a97.131 97.131 0 0 1 19.75-0.6c43.4 3.12 72.75 36.4 72.75 76.6z",
    fill: "#22ceb9",
    fillOpacity: 0.83871
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m548.73 255.35-1.97-14.56a15.71 15.71 0 0 0-5-9.56 15.816 15.816 0 0 0-13.25-4l-3.13 0.43a6.5243 6.5243 0 0 0-4.35 2.53 6.548 6.548 0 0 0-1.29 4.87l4.55 33.54a6.5771 6.5771 0 0 0 5.3 5.57 6.1544 6.1544 0 0 0 1.22 0.12 6.4988 6.4988 0 0 0 0.88-0.06l3.5-0.47a15.791 15.791 0 0 0 10.74-6.43c0.27-0.38 0.53-0.77 0.77-1.17a16.748 16.748 0 0 0 2.03-10.81z",
    fill: "#22ceb9",
    fillOpacity: 0.83871
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m523.36 228.27a6.4317 6.4317 0 0 0-2.33 1.92 6.548 6.548 0 0 0-1.29 4.87l4.55 33.54a6.5771 6.5771 0 0 0 5.3 5.57z",
    fill: "#fff"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "#3f3d56"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m548.73 255.35-1.97-14.56a15.71 15.71 0 0 0-5-9.56l4.53 33.37a6.1759 6.1759 0 0 0 0.41 1.56 16.748 16.748 0 0 0 2.03-10.81z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-204.7 -5.6907) rotate(-7.7255)",
    cx: 532.22,
    cy: 258.91,
    rx: 2.5,
    ry: 7
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-202.31 -6.2574) rotate(-7.7255)",
    cx: 529.22,
    cy: 240.91,
    rx: 2.5,
    ry: 7
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-203.08 -3.6397) rotate(-7.7255)",
    cx: 548.22,
    cy: 247.91,
    rx: 2.5,
    ry: 7
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m460.25 189.99a82.382 82.382 0 0 0-16.35 1.59c-6.06 1.21-12.35 2.66-18.53 4.55-9.65-0.47-16.75-2.97-18.18-6.82 11.25-6.5 24.98-10.69 40.71-12.73a97.131 97.131 0 0 1 19.75-0.6 5.727 5.727 0 0 1 2.72 3.82c0.47 3.48-3.5 7.18-10.12 10.19z",
    fill: "none"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m396.41 287.28-7.7-32.01a6.0237 6.0237 0 0 0-4.88-4.55 6.7333 6.7333 0 0 0-1-0.08 6.0258 6.0258 0 0 0-1.4 0.17l-2.98 0.72a14.904 14.904 0 0 0-10.99 17.96l3.45 14.36a15.845 15.845 0 0 0 5.34 8.62 14.045 14.045 0 0 0 1.36 0.97 14.809 14.809 0 0 0 11.37 1.84l2.97-0.72a5.8401 5.8401 0 0 0 2.17-1.01 5.9933 5.9933 0 0 0 2.29-6.27z",
    fill: "#22ceb9",
    fillOpacity: 0.83871
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-228.45 16.619) rotate(-13.531)",
    cx: 378.63,
    cy: 274.52,
    rx: 2.5,
    ry: 7,
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-229.43 14.363) rotate(-13.531)",
    cx: 368.63,
    cy: 277.52,
    rx: 2.5,
    ry: 7,
    fill: "#3f3d56"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m396.9 287.16-7.7-32.01a6.5317 6.5317 0 0 0-5.29-4.92l10.51 43.72a6.5111 6.5111 0 0 0 2.48-6.79z",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-174.73 -79.585)",
    d: "m369.2 263.15a6.476 6.476 0 0 0-1.17-2.45 14.725 14.725 0 0 0-0.57 8.79l3.45 14.36a15.845 15.845 0 0 0 5.34 8.62z",
    fill: "#3f3d56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.33b3e21ed455d5c7e0e21cd45adedddf.svg";
export { ForwardRef as ReactComponent };